// Webpack Imports
import * as bootstrap from 'bootstrap';
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	function delay(fn, ms = 500) {
		let timer = 0
		return function(...args) {
			clearTimeout(timer)
			timer = setTimeout(fn.bind(this, ...args), ms || 0)
		}
	}

	$(document.body).on('click', '.quantity-counter .increment', function() {
		
		// Enhances number input adding increment buttons
		let dir = $(this).attr('direction')
		let input = $(this).closest('.quantity-counter').find('input')[0]
		let value = input.value

		if(dir =='up')  {
			value++
		}

		if(dir =='down')  {
			if(value > 1) {
				value--
			}
		}

		input.value = value
		$(input).trigger('change')
	})

	let floatingCart = {
		refreshFragments(fragments){
			$.each(fragments, (key, value) =>  $(key).replaceWith(value) );
		},
		el: $('.floating-cart'),
		init(){
			$(document.body).on('click', '.floating-cart-close-button', () => this.close() )
			$(document.body).on('click', '.floating-cart-open-button', () => this.open() )
			$(document.body).on('click', '.floating-cart-toggle-button', () => this.toggle() )
			$(document.body).on('change', '.floating-cart .quantity-input', this.updateQuantity)
		},
		updateQuantity: delay( async(el) => {

			let $input = el.target
			let key = $input.getAttribute('cart-key')
			let quantity = $input.value
			floatingCart.busy()
			let res = await $.post('?wc-ajax=cart/update-quantity', {
				key, 
				quantity
			})
			floatingCart.refreshFragments(res.fragments)
			floatingCart.ready()
		}),
		toggle(){
			if( this.el.length == 0 ) {
				window.location = "/cart"
			}
			this.el.hasClass('open') ? this.close() : this.open()
		},
		ready() {
			this.el.removeClass('busy')
		},
		busy(){
			this.el.addClass('busy')
		},
		refresh( cb = () => {} ){
			this.busy()
			/**
				Take a CB fn that is fired once event concludes.
				Binds temporary fn to apply logic
			*/
			let fn = () => {
				$( document.body ).off( 'wc_fragments_refreshed', fn)	
				cb()
				this.ready()
			}

			$( document.body ).on( 'wc_fragments_refreshed', fn)
			$( document.body ).trigger( 'wc_fragment_refresh' )
		},
		open() {
			if( this.el.length == 0 ) {
				return;
			}
			this.el.addClass('open')
			$('body').addClass('noscroll');
		},
		_close(){
			this.el.removeClass('open');
			$('body').removeClass('noscroll');
		},
		close(delay = 0){
			setTimeout(() => this._close(), delay)
		}
	}
	floatingCart.init();

	$(document).on('submit','form.cart', function(e){
		e.preventDefault()
		submitForm( new FormData(e.target) )
	});

	let submitForm = async(data) => {
		
		$('form.cart').addClass('loading');

		$('form.cart .loading-container').attr('loading', true);

		data.append('action', 'woo-product-add-to-cart');

		let res = await $.ajax({
            type: 'POST',
            url: fweb.ajax_url,
			processData: false,
			contentType: false,
            data,
        });

		let response = JSON.parse(res)
		
		$('form.cart').removeClass('loading');

		$('form.cart .loading-container').attr('loading', false);

		if(response.valid) {
			floatingCart.open()
			floatingCart.refresh( () => floatingCart.close(2000) )
		}
	}

	let fauxVariations = () => {
		let bindEl = $el => {	

			let data = {
				get $value(){
					/**
						Value is the current value of the $select element
					*/
					return data.$select.value
				},
				get $select(){
					/**
						$Select is the target woo select this is bound to
					*/
					return document.querySelector(`select[data-attribute_name='attribute_${data.attribute_name}']`)
				},
				get attribute_name() {
					return $el.getAttribute('data-attribute_name')
				},
				get attribute_value(){
					return $el.getAttribute('data-attribute_value')
				},
				click(){
					$(data.$select)
						.val(data.attribute_value)
						.trigger('change')
				},
				validateIsAvailable(){
					let validValues = Array.from(data.$select.options)
						.map(e => {
							return e.value
						})
					if( !validValues.includes(data.attribute_value) ) {
						return $el.classList.add('disabled')
					}
					$el.classList.remove('disabled')
				},
				inputChange(){
					
					data.validateIsAvailable()
					let { 
						$value,
						attribute_value
					} = data

					data.setOff()

					if($value == '') return;
					if($value == attribute_value) data.setOn()
					
				},
				setOn(){
					$el.classList.add('active')
				},
				setOff() {
					$el.classList.remove('active')
				}
			}
			$el.addEventListener('click', data.click)
			$(data.$select).on('change', data.inputChange)
			/**
				firing to init it.
			*/
			data.inputChange()
			return data;
		}

		let variations = $('.faux-variation-button');

		let elements = variations.map((k, $el) => bindEl($el) )
		

		let revalidateOptions = () => {
			/**
				"Debouncing" so the input events have time to trigger before checking
			*/
			setTimeout(() =>  elements.map( (k, $el) => $el.validateIsAvailable() ), 1);
		}

		$('select[data-attribute_name]').each((k, e) => $(e).on('change', revalidateOptions ) )
		
	}

	fauxVariations();

} )();


jQuery(function() { 
	jQuery.navigation.init();
});

jQuery(window).on('resize', (function() {
	return function(e) {
		jQuery.navigation.repositionDropdowns();
	};
})());

(function ( $ ) {
	$.navigation = {
		/**
		 * Initialize navigation.
		 */
		'init': function () {
			this.handleResponsiveDropdowns();
			this.handleTouchDropdowns();
			this.repositionDropdowns();
			this.activeParentLink();
		},

		/**
		 * Handles dropdowns on touch devices.
		 * @returns {boolean}
		 */
		'handleTouchDropdowns': function () {
			var windowWidth = window.innerWidth;
			if ( windowWidth < 991 ) {
				return false;
			}

			var self = this;
			$( '.caret-wrap' ).on( 'touchstart', function ( e ) {
				e.preventDefault();
				e.stopPropagation();
				var menuItem = $( this ).closest( 'li' );
				if ( $( menuItem ).hasClass( 'dropdown-submenu' ) ) {
					$( menuItem ).siblings().removeClass( 'open' ).find( 'dropdown-submenu' ).removeClass( 'open' );
					$( menuItem ).siblings().find( '.caret-open' ).removeClass( 'caret-open' );
				}
				if ( $( this ).closest( 'li' ).parent().is( '.nav' ) ) {
					self.clearDropdowns();
				}
				$( this ).toggleClass( 'caret-open' );
				$( this ).closest( '.dropdown' ).toggleClass( 'open' );
			} );
			return false;
		},

		'clearDropdowns': function () {
			$( '.dropdown.open' ).removeClass( 'open' );
			$( '.caret-wrap.caret-open' ).removeClass( 'caret-open' );
		},

		/**
		 * Handle the responsive menus under 769px.
		 */
		'handleResponsiveDropdowns': function () {
			var windowWidth = window.innerWidth;
			if ( windowWidth > 768 ) {
				return false;
			}
			$( '.navbar .dropdown > a .caret-wrap' ).on( 'click touchend',
				function ( event ) {
					var caret = $( this );
					event.preventDefault();
					event.stopPropagation();
					//Change caret wrap.
					$( caret ).toggleClass( 'caret-open' );
					//Open dropdown.
					$( caret ).parent().siblings().toggleClass( 'open' );
				}
			);
		},

		/**
		 * Add active parent links on navigation
		 */
		'activeParentLink': function () {
			$( '.navbar .dropdown > a' ).on('click',
				function () {
					//Do nothing if it's an empty hash.
					if ( $( this ).attr( 'href' ) === '#' ) {
						return false;
					}
					location.href = this.href;
					return false;
				}
			);
		},

		/**
		 * Reposition dropdowns if they are out of screen.
		 * @returns {boolean}
		 */
		'repositionDropdowns': function () {
			var windowWidth = window.innerWidth;
			//Do nothing on mobile.
			if ( windowWidth <= 768 ) {
				return false;
			}
			//Do nothing without dropdowns.
			var dropdowns = $( '.dropdown-menu' );
			if ( dropdowns.length === 0 ) {
				return false;
			}
			//Loop dropdowns and move them if needed.
			$.each( dropdowns, function ( key, dropdown ) {
				var submenu = $( dropdown );
				var bounding = submenu.offset().left;
				if ( /webkit.*mobile/i.test( navigator.userAgent ) ) {
					bounding -= window.scrollX;
				}
				var dropdownWidth = submenu.outerWidth();
				if ( bounding + dropdownWidth >= windowWidth ) {
					$( dropdown ).css( { 'right': '100%', 'left': 'auto' } );
				}
			} );
			return false;
		}
	};
} )( jQuery );

document.addEventListener("DOMContentLoaded", function () {

	const checkStep = setInterval(() => {
		const visiblePage = [...document.querySelectorAll('.gform_page')].find(page => {
			return window.getComputedStyle(page).display !== 'none';
		});

		if (!visiblePage) return;

		const match = visiblePage.id?.match(/gform_page_\d+_(\d+)/);
		const step = match ? match[1] : null;

		// Target gravity forms page step where nested form exists
		if (step === "2") {

			const entriesArea = document.querySelector('.gpnf-no-entries');

			// If the entry form has no entries and is currently displaying
			const isEntriesEmpty = entriesArea  &&
				window.getComputedStyle(entriesArea ).display !== 'none';

			if (step === "2" && isEntriesEmpty) {

				clearInterval(checkStep); // stop checking

				// Fire popup modal
				document.getElementsByClassName('gpnf-add-entry')[0]?.click();
			}
		}
	}, 300);

});